module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vue-goodshare-facebook', {
    attrs: {
      "page_url": _vm.url,
      "has_icon": ""
    }
  }), _vm._v(" "), _c('vue-goodshare-twitter', {
    attrs: {
      "page_url": _vm.url,
      "has_icon": ""
    }
  }), _vm._v(" "), _c('vue-goodshare-linked-in', {
    attrs: {
      "page_url": _vm.url,
      "has_icon": ""
    }
  }), _vm._v(" "), _c('vue-goodshare-google-plus', {
    attrs: {
      "page_url": _vm.url,
      "has_icon": ""
    }
  }), _vm._v(" "), _c('vue-goodshare-tumblr', {
    attrs: {
      "page_url": _vm.url,
      "has_icon": ""
    }
  }), _vm._v(" "), _c('vue-goodshare-pinterest', {
    attrs: {
      "page_url": _vm.url,
      "has_icon": ""
    }
  }), _vm._v(" "), _c('vue-goodshare-reddit', {
    attrs: {
      "page_url": _vm.url,
      "has_icon": ""
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bbc0768","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Share.vue
// module id = 1164
// module chunks = 14